import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import '../styles/componentStyles/CircleGraph.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { isMissingChartValue } from '../utils/chartDataAvailability';

const NO_VALUE_PLACEHOLDER = '--';

function CircleGraph(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');
  const hasDisplayableValue = !isMissingChartValue(props.value);

  return (
    <div
      className={`chart-container ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-circle-graph-title ${titleId}-circle-graph-value ${titleId}-circle-graph-descriptor`}
    >
      <div className="title-container" aria-hidden="true">
        <h3 className="title" id={`${titleId}-circle-graph-title`}>
          {props.title}
        </h3>
        <button
          type="button"
          className="wtf transparent-button"
          onClick={() => props.openModal(props.title, props.modalText)}
        >
          <span className="visuallyHidden">{t('open.modal.extra.information')}</span>
          <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" />
        </button>
      </div>
      <div className="chart-box" aria-hidden="true">
        <div className="circle_chart">
          {props.icon && <FontAwesomeIcon icon={props.icon} className="chart-icon" />}
          <p
            className="fs-mask"
            style={{ color: hasDisplayableValue ? props.colour : '#615668' }}
            id={`${titleId}-circle-graph-value`}
          >
            {hasDisplayableValue ? props.value : NO_VALUE_PLACEHOLDER}
          </p>
          {hasDisplayableValue && props.discriptor && (
            <span id={`${titleId}-circle-graph-descriptor`}>{props.discriptor}</span>
          )}
          {!hasDisplayableValue && (
            <span className="circle-no-data">{t('chart.noDataAvailable')}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default CircleGraph;
